module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui basic segment"
  }, [_c('div', {
    staticClass: "ui sixteen wide celled grid"
  }, [_c('div', {
    staticClass: "ui three wide column"
  }, [_c('div', {
    staticClass: "ui blue ribbon label"
  }, [_vm._v(_vm._s(_vm._backlogLabel))]), _vm._v(" "), _c('div', {
    staticClass: "ui circular right floated icon button",
    attrs: {
      "title": _vm._newTaskHint
    },
    on: {
      "click": function($event) {
        return _vm.openTask(null)
      }
    }
  }, [_c('i', {
    staticClass: "plus icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "todo"
  }, [_c('br'), _vm._v(" "), _vm._l((_vm._backlog), function(t) {
    return _c('backlog-card', {
      key: t.id,
      attrs: {
        "task": t,
        "owners": _vm.members,
        "extra-content": _vm._backlogExtraContent,
        "top-content": _vm._backlogTopContent
      },
      on: {
        "openTask": _vm.openTask,
        "confirmDeleteTask": _vm.confirmDeleteTask
      }
    })
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "ui thirteen wide column"
  }, [_c('div', {
    staticClass: "ui sixteen column celled grid"
  }, [_c('div', {
    staticClass: "equal height row"
  }, [_c('div', {
    staticClass: "three wide center aligned column"
  }, [_c('div', {
    staticClass: "ui basic label"
  }, [_c('i', {
    staticClass: "users icon"
  }), _vm._v(" " + _vm._s(_vm._teamLabel) + "\n\t\t\t\t\t\t\t"), _c('a', {
    staticClass: "detail",
    attrs: {
      "title": _vm._newMemberHint
    },
    on: {
      "click": _vm.newMember
    }
  }, [_c('i', {
    staticClass: "teal plus icon"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "five wide column"
  }, [_c('div', {
    staticClass: "ui yellow ribbon label"
  }, [_vm._v(_vm._s(_vm._doingLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "four wide column"
  }, [_c('div', {
    staticClass: "ui red ribbon label"
  }, [_vm._v(_vm._s(_vm._blockedLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "four wide column"
  }, [_c('div', {
    staticClass: "ui green ribbon label"
  }, [_vm._v(_vm._s(_vm._doneLabel))])])]), _vm._v(" "), _vm._l((_vm._team), function(member) {
    return _c('div', {
      key: member.id,
      staticClass: "equal height row"
    }, [_c('div', {
      staticClass: "three wide column"
    }, [(member.avatar === undefined) ? _c('img', {
      staticClass: "ui avatar image",
      attrs: {
        "src": require("./assets/unsigned.png")
      }
    }) : _vm._e(), _vm._v(" "), (member.avatar !== undefined) ? _c('img', {
      staticClass: "ui avatar image",
      attrs: {
        "src": _vm.getImage(member.avatar)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "ui basic left pointing label"
    }, [_vm._v(_vm._s(member.name))])]), _vm._v(" "), _c('div', {
      staticClass: "five wide column doing",
      attrs: {
        "owner": member.id
      }
    }, _vm._l((member.doing), function(t) {
      return _c('task-card', {
        key: t.id,
        attrs: {
          "task": t,
          "extra-content": _vm._taskExtraContent,
          "top-content": _vm._taskTopContent
        },
        on: {
          "openTask": _vm.openTask,
          "confirmDeleteTask": _vm.confirmDeleteTask
        }
      })
    }), 1), _vm._v(" "), _c('div', {
      staticClass: "four wide column blocked",
      attrs: {
        "owner": member.id
      }
    }, _vm._l((member.blocked), function(t) {
      return _c('task-card', {
        key: t.id,
        attrs: {
          "task": t,
          "extra-content": _vm._taskExtraContent,
          "top-content": _vm._taskTopContent
        },
        on: {
          "openTask": _vm.openTask,
          "confirmDeleteTask": _vm.confirmDeleteTask
        }
      })
    }), 1), _vm._v(" "), _c('div', {
      staticClass: "four wide column done",
      attrs: {
        "owner": member.id
      }
    }, _vm._l((member.done), function(t) {
      return _c('task-card', {
        key: t.id,
        attrs: {
          "task": t,
          "extra-content": _vm._taskExtraContent,
          "top-content": _vm._taskTopContent
        },
        on: {
          "openTask": _vm.openTask,
          "confirmDeleteTask": _vm.confirmDeleteTask
        }
      })
    }), 1)])
  })], 2)])]), _vm._v(" "), _c('task-dialog', {
    ref: "dialog",
    attrs: {
      "owners": _vm.members
    },
    on: {
      "updateTask": _vm.updateTask,
      "addTag": _vm.addTag,
      "deleteTag": _vm.deleteTag
    }
  }), _vm._v(" "), _c('confirm-dialog', {
    ref: "confirm",
    on: {
      "deleteTask": _vm.deleteTask
    }
  }), _vm._v(" "), _c('member-dialog', {
    ref: "memberDialog",
    on: {
      "updateMember": _vm.updateMember
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37a6d7aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/semanticKanban.vue
// module id = 246
// module chunks = 1